import { SET_IS_IN_MOBILE } from '../actionConstants';

export const setIsInMobileAction = (payload) => {
  return {
    type: SET_IS_IN_MOBILE,
    payload,
  };
};
